import Swal from "sweetalert2";

// standard popups, same as the savethem admin
export const notifySuccess = (title) => Swal.fire({ title, icon: "success", timer: 1000, showConfirmButton: false });
export const notifyError = (title, text) => Swal.fire({ title, text, icon: "error" });

export const confirmDelete = async (title) => {
  const result = await Swal.fire({
    title,
    text: "You won't be able to revert this!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Confirm",
    cancelButtonText: "Cancel",
  });
  return result.isConfirmed;
};

export const readImageSize = (file) =>
  new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve([img.width, img.height]);
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error("Could not load image"));
    };
    img.src = url;
  });

export const fileExt = (file) => file.name.split(".").pop().toLowerCase();

/** Returns an error message, or "" when the image has an allowed type, size and dimensions. */
export const checkImage = async (file, { exts, width, height, maxMb = 5 }) => {
  if (!file.type.startsWith("image/") || !exts.includes(fileExt(file))) {
    return `Only ${exts.join(", ").toUpperCase()} files are allowed.`;
  }
  if (file.size > maxMb * 1024 * 1024) return `Filesize exceeds max limit ${maxMb} MB`;
  try {
    const [w, h] = await readImageSize(file);
    if (w !== width || h !== height) return `Invalid size! Required: ${width}x${height}`;
  } catch (err) {
    return err.message;
  }
  return "";
};

// <input type="color"> only accepts #rrggbb
export const toHexColor = (value, fallback = "#000000") => {
  const v = String(value || "").trim();
  if (/^#[0-9a-f]{6}$/i.test(v)) return v;
  if (/^#[0-9a-f]{3}$/i.test(v)) return `#${v[1]}${v[1]}${v[2]}${v[2]}${v[3]}${v[3]}`;
  return fallback;
};

export const asArray = (value) => (Array.isArray(value) ? value : []);

// themesdata flags are stored as 1/0 (or the strings "true"/"false" in the defaults); only "1" turns a switch on
export const isOn = (value) => String(value) === "1";
